import React, { useState, useEffect } from "react";
import { Button, ButtonProps } from "react-bootstrap";
import { useTranslations } from "../../contexts/translationContext";

export interface BtnProps extends ButtonProps {
    text?: string
    fill?: boolean
    onClick?: (event: React.MouseEvent<HTMLElement>) => void
}

const Btn: React.FC<BtnProps> = ({ text, fill, active, variant, size, type, href, disabled, onClick, children }) => {
    const [buttonText, setButtonText] = useState<string | undefined>(text)
    const { translate } = useTranslations();

    useEffect(() => {
        if (text) {
            translate(text, 'Buttons').then(translated => setButtonText(translated));
        }
    });

    if (!variant) variant = 'secondary'

    let className = 'btn'
    if (fill !== false)
        className = 'btn-fill'

    return (
        <Button className={className} active={active} variant={variant} size={size} type={type} href={href} disabled={disabled} onClick={onClick}>
            {buttonText}
            {children}
        </Button>
    );
}
export default Btn;